<template>
    <div class="content">
        <!-- <img :src="oDetail.model.url" alt="" /> -->
        <div v-html="sHtml"></div>
        <div class="bottom_btn">
            <div class="item" @click="getOpen(index)" v-for="(item, index) in arrNav" :key="index">
                {{ item.name }}
            </div>
        </div>
        <shareLink :bShowNrom.sync="bShowNrom" :confit="confit"></shareLink>
    </div>
</template>
<script>
import {requestAesPost5} from '@/libsV2/requestAes.js'
import shareLink from "@/components/goods/details/share/index.vue";
import { getWxSingleConfig } from "@/js/wx.js";
export default {
    components: {
        shareLink,
    },
    data() {
        return {
            bShowNrom: false,
            arrNav: [
                { name: "详情" },
                { name: "分享" },
                { name: "内容" },
                // { name: "分享" },
            ],
            oDetail: {
                model: {
                    url: "",
                },
            },
            nOpenIndex: 0,
            itemId: 0,
            sHtml: "",
            confit: {},
        };
    },
    created() {
        let that = this;
            let id = that.$route.query.id;
            that.getGoodDatail(id);
    },
    methods: {
        //jssdk 微信分享
        wxStare(confit) {
            getWxSingleConfig(confit);
        },
        getGoodDatail(id) {
            let that = this;
            this.$store.commit("loadSwitch", true);
            requestAesPost5('shop/goods/item',{ id: id }).then((res) => {
                //  console.log("商品详情", res);
                document.title = res.data.data.result.goods_name;
                that.itemId = res.data.data.result.id;
                if (res.data.data.result.materal != null) {
                    that.getGoodMateral(res.data.data.result.materal);
                } else {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: "未绑定内容",
                        duration: 1200,
                    });
                }
            });
        },
        getGoodMateral(materal) {
            let that = this;
            requestAesPost5('shop/goods/getGoodsMateral',{ materialid: materal }).then((res) => {
                let oDetail = res.data.data.result;
                if(oDetail == null){
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: "请确认绑定内容是否正确",
                        duration: 1200,
                    });
                    return false
                }
                // if (res.result.model.content != "") {
                switch (oDetail.model.type) {
                    case 1:
                        var sHtml = oDetail.model.content.replace(
                            /\<img/gi,
                            '<img style="width:100% !important;"'
                        );
                        break;
                    case 2:
                        var sHtml =
                            "<img src=" +
                            "'" +
                            oDetail.model.url +
                            "'" +
                            " style='width:100% !important;height:auto;'/>";
                        break;
                    case 8:
                        sHtml =
                            "<img src=" +
                            "'" +
                            oDetail.model.moments_pics[0].material_file +
                            "'" +
                            " style='width:100% !important;height:auto;'/>"; // 图片
                        break;
                }
                this.$store.commit("loadSwitch", false);
                that.sHtml = sHtml;
                that.oDetail = oDetail;
                let confit = {
                    share_friend_title: "智能选型",
                    share_friend_desc: res.data.data.result.model.title,
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                    share_link: window.location.href,
                };
                that.confit = confit;
                that.wxStare(confit);
                // } else {
                //     this.$store.commit("loadSwitch", false);
                //     this.$toast({
                //         message: "未添加商品素材",
                //         duration: 1200,
                //     });
                // }
            });
        },
        getOpen(index) {
            this.nOpenIndex = index;
            switch (index) {
                case 0:
                    break;
                case 1:
                    this.bShowNrom = true;
                    // window.location.href =
                    //     "https://pro-mixed.babycdn.com/2020/ao/vr0628/scene/index2.html";
                    break;
                case 2:
                    this.$router.push({
                        path: `/shoppcontent/index?id=${this.itemId}`,
                    });
                    break;
                case 3:
                    this.bShowNrom = true;
                    break;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "details.scss";
</style>
